import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeMenu();

    const element = document.getElementById(targetId);
    if (element) {
      const headerHeight = 80; // Approximate header height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleBookingClick = () => {
    window.open(
      "https://calendly.com/bsquarefinancial-info/1-on-1-bsquare-15-minute-cash-flow-audit",
      "_blank",
      "noopener,noreferrer"
    );
    closeMenu();
  };

  return (
    <header className="header">
      <nav className="header-nav">
        <a href="#home" className="logo" onClick={(e) => handleNavClick(e, "home")}>
          <img src="/logo.png" alt="BSquare Financial" className="logo-image2" />
          {/* <span className="logo-text">BSquare</span> */}
        </a>
        <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger ${isMenuOpen ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <a href="#home" className="nav-link" onClick={(e) => handleNavClick(e, "home")}>
            Home
          </a>
          <a href="#intro" className="nav-link" onClick={(e) => handleNavClick(e, "intro")}>
            Intro
          </a>
          <a href="#financial-service" className="nav-link" onClick={(e) => handleNavClick(e, "financial-service")}>
            Financial service
          </a>
          <a href="#our-process" className="nav-link" onClick={(e) => handleNavClick(e, "our-process")}>
            Our Process
          </a>
          <button className="cta-button mobile-cta" onClick={handleBookingClick}>
            Book a Confidential Consultation
            <span className="arrow-icon">↗</span>
          </button>
        </div>
        <div className="header-right">
          <button className="cta-button" onClick={handleBookingClick}>
            Book a Confidential Consultation
            <span className="arrow-icon">↗</span>
          </button>
        </div>
      </nav>
      <div className={`mobile-overlay ${isMenuOpen ? "active" : ""}`} onClick={closeMenu}></div>
    </header>
  );
};

export default Header;
